import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';


export default function PharmaorderInfoForView(){
  const { pharmaorderObj} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll",  maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white', padding:.25}}
      >
        <Grid item lg={2} xs={6}><FieldView label="Order Id"  value={ pharmaorderObj.orderid!==null && pharmaorderObj.orderid!==undefined?pharmaorderObj.orderid:'NOT KNONWN' }/></Grid>
        <Grid item lg={2} xs={6}><FieldView label="Party Name"  value={ pharmaorderObj.partyname!==null && pharmaorderObj.partyname!==undefined?pharmaorderObj.partyname:'NOT KNONWN' }/></Grid>
        <Grid item lg={2} xs={6}><FieldView label="Order Value"  value={ pharmaorderObj.ordervalue!==null && pharmaorderObj.ordervalue!==undefined?pharmaorderObj.ordervalue:'NOT KNONWN' }/></Grid>
        {/* <Grid item lg={2} xs={6}><FieldView label="Dispatch Date" value={ pharmaorderObj.dispatchdate!==null && pharmaorderObj.dispatchdate!==undefined?pharmaorderObj.dispatchdate.split('T')[0]:'NOT KNONWN' }/></Grid>
        <Grid item lg={2} xs={6}><FieldView label="Status"  value={ pharmaorderObj.orderstatus!==null && pharmaorderObj.orderstatus!==undefined?pharmaorderObj.orderstatus:'NOT KNONWN' }/></Grid> */}
        <Grid item lg={6} xs={6}><FieldView label="Executive Name"  value={ pharmaorderObj.executivename!==null && pharmaorderObj.executivename!==undefined?pharmaorderObj.executivename:'NOT KNONWN' }/></Grid>
        </Grid>
      </Grid>
      </Box>
    )
}